import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const LONG_TOUCH_INTERVAL = 300;
let intervalID;

const handleTouchStart = (e, onClick) => {
  $(e.target).one('click mousedown', event => {
    event.preventDefault();
    event.stopPropagation();
  });

  if (intervalID) {
    window.clearTimeout(intervalID);
  }

  onClick();

  intervalID = window.setTimeout(onClick, LONG_TOUCH_INTERVAL);
};

const handleTouchEnd = () => {
  window.clearTimeout(intervalID);
  intervalID = null;
};

const Button = props => {
  const {
    inputID,
    ariaLabel,
    className,
    disabled,
    max,
    min,
    value,
    onClick,
    children,
  } = props;

  return (
    <button
      aria-controls={inputID}
      aria-disabled={disabled}
      aria-label={ariaLabel}
      className={classNames('btn', 'btn-info', className)}
      disabled={disabled}
      type="button"
      aria-valuemax={max}
      aria-valuemin={min}
      aria-valuenow={value}
      onKeyPress={onClick}
      onMouseDown={onClick}
      onTouchStart={e => handleTouchStart(e, onClick)}
      onTouchEnd={() => handleTouchEnd()}>
      {children}
    </button>
  );
};

Button.propTypes = {
  inputID: PropTypes.string,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  max: PropTypes.string,
  min: PropTypes.string,
  value: PropTypes.number,
  onClick: PropTypes.func,
  children: PropTypes.element,
}.isRequired;

export default Button;
